export default "__VITE_ASSET__CAOqpvaR__"